import React, { useState } from "react";
import { Check, Shield, Star, Crown, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./VGD.css";
import logo from "../assets/logo.png";
import FormModal from "./FormModal";
// Import local gallery images
import img1 from "../assets/photo1.jpg";
import img2 from "../assets/photo2.jpg";
import img3 from "../assets/photo3.jpg";
import img4 from "../assets/photo4.jpg";



export default function VGDSubscriptionPage() {
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [showLoginToast, setShowLoginToast] = useState(false);
  const navigate = useNavigate();

  // Disable right-click, screenshot shortcuts, and image dragging
  React.useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable screenshot shortcuts and other key combinations
    const handleKeyDown = (e) => {
      // Prevent PrintScreen, Cmd+Shift+3/4/5 (Mac), Windows+Shift+S, etc.
      if (
        e.key === 'PrintScreen' ||
        (e.metaKey && e.shiftKey && ['3', '4', '5'].includes(e.key)) ||
        (e.key === 's' && (e.metaKey || e.ctrlKey) && e.shiftKey)
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable drag on all images
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);

    // Add CSS to prevent selection and dragging
    const style = document.createElement('style');
    style.innerHTML = `
      .vgd-page-container * {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
      }
      .vgd-gallery-item img {
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
      document.head.removeChild(style);
    };
  }, []);

  
const plans = [
  {
    name: "Pack 1",
    price: "19.99",
    originalPrice: "0",
    duration: "Acesso único",
  features: ["+ de 100 fotos de cueca, poses provocantes e corpo definido 😏",
      "Nada explícito, só o suficiente pra mexer com a imaginação 👀",
      "🔒 Exclusivas & privadas | 📥 Entrega imediata"],
    popular: false,
    color: "from-blue-500 to-blue-600"
  },
  {
    name: "Pack 2",
    price: "59.99",
    originalPrice: "0",
    duration: "Acesso único",
       features: ["Todas as mídias em Full HD",
      "Para quem quer ver tudo mesmo… 😈",
      "150 fotos + 25 vídeos intensos",
      "* Totalmente sem censura",
      "* Vídeos com final feliz 💦",
      "* Posições e takes bem íntimos 📸🎥",
      "✔ Acesso privado e imediato"],
    popular: true,
    color: "from-purple-500 to-pink-500"
  },
  {
    name: "Pack 3",
    price: "199.99",
    originalPrice: "0",
    duration: "Acesso único + VIP",
     features: [
        "Pack 3 VIP — Domine a cena 😈",
      "Me diz o que você quer ver…",
      "Eu gravo um vídeo exclusivo só pra você 👅",
      "Nada editado, nada repetido.",
      "E tem mais…",
      "🎥 50 vídeos explícitos",
      "🔥 3 vídeos longos (até 10 minutos)",
      "📸 150 fotos íntimas e exclusivas"
      ],
    popular: false,
    color: "from-amber-500 to-orange-500"
  }
];


  const faqs = [
    {
      question: "Como funciona a compra e o acesso aos conteúdos?",
      answer:
        "Após a confirmação do pagamento, você receberá acesso imediato ao conteúdo exclusivo diretamente na sua conta.",
    },
    {
      question: "As prévias são desfocadas. O conteúdo final também?",
      answer:
        "Não! As prévias são desfocadas apenas para proteção. Todo o conteúdo final é em alta qualidade, sem desfoque.",
    },
    {
      question: "Quais formas de pagamento você aceita?",
      answer:
        "Aceitamos PIX (instantâneo) e cartão de crédito em até 12x sem juros.",
    },
  ];

  const handlePlanClick = (planName) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.username) return setShowLoginToast(true);
      navigate("/CheckoutPage", { state: { plan: planName } });
    } catch {
      setShowLoginToast(true);
    }
  };

  const handleWatchNow = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || !user.username) return setShowLoginToast(true);
      navigate("/dashboard");
    } catch {
      setShowLoginToast(true);
    }
  };

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  return (
    <div className="vgd-page-container">
      {/* ✅ Login Toast */}
      {showLoginToast && (
        <>
          <div
            className="vgd-login-overlay"
            onClick={() => setShowLoginToast(false)}
          />
          <div className="vgd-login-toast">
            <div className="vgd-toast-icon-wrapper">
              <Shield className="vgd-toast-icon" />
            </div>
            <h3 className="vgd-toast-title">Login Necessário</h3>
            <p className="vgd-toast-message">
              Faça login para acessar este conteúdo exclusivo e começar a aproveitar!
            </p>
            <button
              className="vgd-toast-button"
              onClick={() => {
                setShowLoginToast(false);
                navigate("/login");
              }}
            >
              Fazer Login Agora
            </button>
          </div>
        </>
      )}

     <header className="vgd-header">
  <div className="vgd-header-content">

    {/* LEFT — LOGO + MODEL BUTTON */}
    <div className="vgd-header-left">
      <img src={logo} alt="VGD Logo" className="vgd-logo-img" />

      <button
        className="vgd-btn-signup vgd-model-btn"
        onClick={() => navigate("/FormModal")}
      >
        Quero ser modelo
      </button>
    </div>

    {/* RIGHT — AUTH BUTTONS (DESKTOP) */}
    <div className="vgd-auth-buttons">
      <button className="vgd-btn-signup" onClick={() => navigate("/login")}>
        Logar
      </button>

      <button className="vgd-btn-signup" onClick={() => navigate("/login")}>
        Cadastre-se como cliente
      </button>
    </div>

    {/* MOBILE HAMBURGER */}
    <div className="vgd-hamburger" onClick={() =>
      document.querySelector(".vgd-mobile-menu").classList.toggle("active")
    }>
      ☰
    </div>

  </div>

  {/* MOBILE MENU DROPDOWN */}
  <div className="vgd-mobile-menu">
    <button className="vgd-btn-login" onClick={() => navigate("/login")}>
      Logar
    </button>

    <button className="vgd-btn-signup" onClick={() => navigate("/login")}>
      Cadastre-se como cliente
    </button>
 <button className="vgd-btn-signup" onClick={() => navigate("/Landingpage")}>
      Landing-page
    </button>
    <button className="vgd-btn-signup vgd-model-btn" onClick={() => navigate("/login")}>
      Quero ser modelo
    </button>
  </div>
</header>


<section className="vgd-hero">
  <div className="vgd-hero-content">
    <h1 className="vgd-hero-title">
  Nem toda corrida é comportada.<br />
  Confira as gostosuras aqui.<br />
  Seu motorista
  <span className="vgd-hero-18-badgeName"> 18+ </span>
</h1>

    <button className="vgd-hero-btn" onClick={() => navigate("/login")}>Assine agora</button>
  </div>
</section>








     

      {/* ✅ Subscription Plans */}
      <section className="vgd-section">
        <h3 className="vgd-section-title vgd-text-center">Planos de Assinatura</h3>
        <div className="vgd-plans-container">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`vgd-plan-card ${
                plan.popular ? "vgd-plan-popular" : ""
              }`}
            >
              {plan.popular && <div className="vgd-popular-badge">Mais Popular</div>}
              <div className="vgd-plan-icon">{plan.icon}</div>
              <h4 className="vgd-plan-name">{plan.name}</h4>
              <div className="vgd-plan-price">R$ {plan.price}</div>
              <ul className="vgd-features-list">
                {plan.features.map((feature, i) => (
                  <li key={i} className="vgd-feature-item">
                    <Check className="vgd-check-icon" size={20} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handlePlanClick(plan.name)}
                className="vgd-btn-primary vgd-btn-full"
              >
                🎬 Assinar Agora
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ✅ FAQ */}
      <section className="vgd-section">
        <h3 className="vgd-section-title vgd-text-center">Dúvidas Frequentes</h3>
        <div className="vgd-faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`vgd-faq-item ${
                expandedFaq === index ? "vgd-faq-active" : ""
              }`}
            >
              <button
                onClick={() => toggleFaq(index)}
                className="vgd-faq-button"
              >
                <span className="vgd-faq-question">{faq.question}</span>
                <span
                  className={`vgd-faq-arrow ${
                    expandedFaq === index ? "vgd-faq-arrow-open" : ""
                  }`}
                >
                  ▸
                </span>
              </button>
              {expandedFaq === index && (
                <div className="vgd-faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ✅ Footer */}
      <footer className="vgd-footer">
        <p className="vgd-footer-text">©️ 2025 Agência VGD — Todos os direitos reservados.</p>
        <p className="vgd-footer-subtext">
          Este site é destinado a maiores de 18 anos. Ao continuar,<br />
          você declara ser maior de idade.
        </p>
      </footer>

      {/* ✅ Floating Button */}
      <button
        onClick={handleWatchNow}
        className="vgd-floating-button"
        aria-label="Watch Now"
      >
        🎬
      </button>
    </div>
  );
}
